import React from "react";
import { motion } from "framer-motion";
import { fadeIn } from "../../../variants";

import "./index.css";
import LogoDesc from "../../assets/logo/logoblack.jpg";

const Description = () => {
  // Fonction pour empêcher les actions de copier, coller et glisser-déposer
  const preventDefaultActions = (e) => {
    e.preventDefault();
  };
  return (
    <div>
      <motion.div
        variants={fadeIn("right", 0.2)}
        initial="hidden"
        whileInView={"show"}
        viewport={{ once: false, amount: 0.3 }}
        className="description"
      >
        <img
          className="logo-desc"
          onContextMenu={preventDefaultActions} // Empêche le clic droit
          onDragStart={preventDefaultActions} // Empêche le glisser-déposer
          onMouseDown={preventDefaultActions} // Empêche d'autres actions de souris potentiellement indésirables
          src={LogoDesc}
          alt="logo-description"
        />
        <h2 className="description-title">PRODUCTION & ÉDITION MUSICALE</h2>
        <p className="description-text" style={{ alignContent: "center" }}>
          Fondée en 2021 par Vincent Fernandel, VFP est une société dédiée à la
          production et à l’édition musicale, ainsi qu’à la création
          audiovisuelle.
        </p>
      </motion.div>
    </div>
  );
};

export default Description;
